import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGoodsCategoryList, updateGoodsCategory, createGoodsCategory, deleteGoodsCategory } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from "vuex";

var _this;

export default {
  name: 'BianlidianCategory',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  props: ['isForComponent', 'componentCategoryNo', 'componentParentNo'],
  data: function data() {
    return {
      data: [],
      type: '',
      expandedArr: [],
      dialogVisible: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      formData: {
        parentNo: 0,
        parentName: '根目录',
        categoryNo: '',
        name: '',
        remark: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入目录名称',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.loadGoodsCategoryTree(function () {
                _this2.resetForComponent();
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    loadGoodsCategoryTree: function loadGoodsCategoryTree(fn) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;
                _context3.next = 3;
                return getGoodsCategoryList();

              case 3:
                res = _context3.sent;
                that.toTreeData(res.data.list, 'categoryNo', 'parentNo', 'name');
                that.$refs.tree.setCheckedKeys([]);

                if (that.formData.parentNo > 0) {
                  that.expandedArr.push(that.formData.parentNo);
                }

                if (fn) {
                  fn();
                }

                console.log(res);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    toTreeData: function toTreeData(data, id, pid, name) {
      // 找到当前组织的直系子节点
      var parent = [];

      for (var i = 0; i < data.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (data[i][pid] == '0') {
          var obj = {
            label: data[i][name],
            id: data[i][id],
            pid: 0,
            plabel: '',
            remark: data[i]['remark'],
            children: []
          };
          parent.push(obj); // 数组加数组值
        }
      }

      this.children(parent, data, id, pid, name);
      this.data = parent;
      console.log(parent);
    },
    children: function children(parent, data, id, pid, name) {
      // 给当前组织的直系子节点添加剩下的子节点
      var that = this;

      if (data) {
        for (var i = 0; i < parent.length; i++) {
          for (var j = 0; j < data.length; j++) {
            // eslint-disable-next-line eqeqeq
            if (parent[i].id == data[j][pid]) {
              // console.log(data[j].name)
              var obj = {
                label: data[j].name,
                id: data[j][id],
                pid: parent[i].id,
                plabel: parent[i].label,
                remark: parent[i].remark,
                children: []
              };
              parent[i].children.push(obj);
            }
          }

          that.children(parent[i].children, data, id, pid);
        }
      }
    },
    handleCheckChange: function handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        var arr = [data.id];
        this.$refs.tree.setCheckedKeys(arr);
      }
    },
    handleNodeCollapse: function handleNodeCollapse(data, node, indeterminate) {
      this.expandedArr = this.expandedArr.slice(this.expandedArr.indexOf(data.id), 0);
    },
    onAdd: function onAdd() {
      var that = this;
      var nodes = that.$refs.tree.getCheckedNodes();

      if (nodes.length > 0) {
        that.formData.parentNo = nodes[0].id;
        that.formData.parentName = nodes[0].label;
      } else {
        that.formData.parentNo = 0;
        that.formData.parentName = '根目录';
      }

      that.type = 'add';
      that.dialogVisible = true;
    },
    onUpdate: function onUpdate() {
      var that = this;
      var nodes = that.$refs.tree.getCheckedNodes();

      if (nodes.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择要修改类目'
        });
        return;
      }

      debugger;
      that.formData.parentNo = nodes[0].pid;
      that.formData.parentName = nodes[0].plabel;
      that.formData.categoryNo = nodes[0].id;
      that.formData.name = nodes[0].label;
      that.formData.remark = nodes[0].remark;
      that.type = 'update';
      that.dialogVisible = true;
    },
    onDel: function onDel() {
      var that = this;
      var nodes = that.$refs.tree.getCheckedNodes();

      if (nodes.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择要删除类目'
        });
        return;
      }

      that.formData.parentNo = nodes[0].pid;
      that.formData.parentName = nodes[0].plabel;
      that.formData.categoryNo = nodes[0].id;
      that.formData.name = nodes[0].label;
      that.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteGoodsCategory(that.formData).then(function (res) {
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.loadGoodsCategoryTree(function () {
              that.closeDialog();
            });
          }
        }, function (err) {});
      }).catch(function (err) {});
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.type = '';
      this.formData = {
        parentNo: 0,
        parentName: '根目录',
        name: '',
        remark: ''
      };
    },
    enterDialog: function enterDialog() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4; // eslint-disable-next-line eqeqeq

                if (that.type == 'add') {
                  that.$refs['formData'].validate(function (valid) {
                    // eslint-disable-next-line no-empty
                    if (valid) {
                      createGoodsCategory(that.formData).then(function (res) {
                        // eslint-disable-next-line eqeqeq
                        if (res.code == 0) {
                          that.$message({
                            type: 'success',
                            message: res.msg
                          });
                          that.loadGoodsCategoryTree(function () {
                            that.closeDialog();
                          });
                        } // eslint-disable-next-line handle-callback-err

                      }, function (err) {});
                    } else {
                      return false;
                    }
                  });
                }

                if (that.type == 'update') {
                  that.$refs['formData'].validate(function (valid) {
                    // eslint-disable-next-line no-empty
                    if (valid) {
                      updateGoodsCategory(that.formData).then(function (res) {
                        // eslint-disable-next-line eqeqeq
                        if (res.code == 0) {
                          that.$message({
                            type: 'success',
                            message: res.msg
                          });
                          that.loadGoodsCategoryTree(function () {
                            that.closeDialog();
                          });
                        } // eslint-disable-next-line handle-callback-err

                      }, function (err) {});
                    } else {
                      return false;
                    }
                  });
                }

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getSelectionForComponent: function getSelectionForComponent() {
      return this.$refs.tree.getCheckedNodes();
    },
    resetForComponent: function resetForComponent() {
      debugger;

      if (this.isForComponent) {
        if (this.componentCategoryNo) {
          this.$refs.tree.setCheckedKeys([this.componentCategoryNo]);
        } else {
          this.$refs.tree.setCheckedKeys([]);
        }

        if (this.componentParentNo) {
          this.expandedArr = [];
          this.expandedArr.push(this.componentParentNo);
        } else {
          this.expandedArr = [];
        }
      }
    }
  }
};